export const INVALID_EMAIL_MESSAGE = 'Please enter valid email address';
export const EMAIL_REQUIRED = 'Please enter your email address';
export const PASSWORD_REQUIRED = 'Please enter your password';
export const SOMETHING_WENT_WRONG = 'Something went wrong';
